export { default } from './nosto-recommendations-block';
